import request from "@/utils/request";


/**
 * 获取易制毒化学品细类(bm-mc)
 */
export const getHxpListByLevel4 = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/getHxpList`,
  method: 'get',
})

/**
 * 行情数据列表获取
 */
export const getGmzHqsjfxData = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/getGmzHqslfx`,
  method: 'post',
  data,
  timeout: 1000000
})

/**
 * 行情数据导出
 */
export const exportGmzHqsjfxData = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/exportGmzHqslfx`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})

/**
 * 将数据新增到行情数据分析Table中
 */
export const addlistData = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/addlistData`,
  method: 'post',
  data,
  timeout: 1000000
})

//获取或处理已新增到行情分析表中的相关数据

/**
 * 行情数据Tabel获取
 */
export const getTableListData = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/getList`,
  method: 'post',
  data,
  timeout: 1000000
})

/**
 * 行情数据Tabel导出
 */
export const exportTableListData = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/exportList`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})

/**
 * 待处置的行情数据条数
 */
export const getTableDczCount = () => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/getDczCount`,
  method: 'get',
})


/**
 * 获取待处置的行情数据详情
 */
export const getTableDczDeatil = (id) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/dczHqsjfxDeatil/${id}`,
  method: 'get',
})

/**
 * 保存待处置的行情数据详情（初始保存）
 */
export const editDealSaveTableData = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/editDealSave`,
  method: 'put',
  data
})

/**
 * 编辑保存已处置的行情数据详情
 */
export const editHisSaveTableData = (data) => request({
  url: `/yzdservice/enterprise/nbry/hqsjfx/editHisSave`,
  method: 'put',
  data
})
